import attendanceSummary from '@/api/report/attendance-summary'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  orgChartStructures: [],
  employees: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_ORG_CHART_STRUCTURE(state, data) {
    state.orgChartStructures = data
  },
  CLEAR_EMPLOYEE(state) {
    state.employees = []
  },
  SET_EMPLOYEE(state, data) {
    state.employees = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attributes
    )
    return attendanceSummary.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  async getOrgChartStructure(context, attributes = {}) {
    let response = await attendanceSummary.orgChartStructure({
      params: attributes
    })
    context.commit('SET_ORG_CHART_STRUCTURE', response.data)
  },
  async clearEmployee(context) {
    context.commit('CLEAR_EMPLOYEE')
  },
  async getEmployee(context, { id }) {
    let response = await attendanceSummary.employee(id)
    context.commit('SET_EMPLOYEE', response.data)
  },
  // generate attendance Detail
  attendanceSummaryExcel(context, data) {
    return attendanceSummary.attendanceSummaryExcel(data)
  }
}
